export function determineStrDate2(value?: string): string | null {
    if (value != null) {
        return new Date(
            value.trim().toLowerCase().endsWith('z') ? value : `${value}Z`,
        ).toISOString();
    }
    return null;
}
